import React from "react";
import { formatRupiah } from "../../../../../../shared/helpers";

const ContentAdditionalInfo = (props) => {
  const { data } = props;
  return (
    <>
      <div className="row current my-1">
        <label className="col-lg-3 col-md-3 col-sm-6 col-xs-6 font-size-main text-neutral-n8 font-weight-w500 text-capitalize">
          Current Salary
        </label>
        <label className="col-lg-2 col-md-2 col-sm-3 col-xs-3  font-size-main text-neutral-n8 font-weight-w400">
          {(() => {
            if (data.curr_salary) {
              return formatRupiah(data.curr_salary, "Rp. ");
            } else {
              return "Rp. ";
            }
          })()}
        </label>
        <div className="current_benefits col-lg-7 col-md-7 col-sm-3 col-xs-3  font-size-main">
          <label className="font-weight-w500 text-capitalize text-neutral-n8">
            Current Benefits
          </label>
          <ul>
            {(() => {
              if (data.curr_benefits) {
                return data.curr_benefits.map((item, i) => (
                  <li key={i}>{item}</li>
                ));
              } else {
                return "";
              }
            })()}
          </ul>
        </div>
      </div>
      <div className="row expected my-1">
        <label className="col-lg-3 col-md-3 col-sm-6 col-xs-6  font-size-main text-neutral-n8 font-weight-w500 text-capitalize">
          Expected Salary
        </label>
        <label className="col-lg-2 col-md-2 col-sm-3 col-xs-3  font-size-main text-neutral-n8 font-weight-w400">
          {(() => {
            if (data.expected_salary) {
              return formatRupiah(data.expected_salary, "Rp. ");
            } else {
              return "Rp. ";
            }
          })()}
        </label>
        <div className="current_benefits col-lg-7 col-md-7 col-sm-3 col-xs-3  font-size-main">
          <label className="font-weight-w500 text-capitalize text-neutral-n8">
            Expected Benefits
          </label>
          <ul>
            {(() => {
              if (data.expected_benefits) {
                return data.expected_benefits.map((item, i) => (
                  <li key={i}>{item}</li>
                ));
              } else {
                return "";
              }
            })()}
          </ul>
        </div>
      </div>
    </>
  );
};

export default ContentAdditionalInfo;
